<template>
  <main class="main" role="main">
    <div class="main_con">
      <div class="gift_list">
        <benefitCard
          v-for="section in sections.content"
          :key="section.id"
          :section="section"
          @selectBenefit="goBenefit"
        ></benefitCard>
      </div>
    </div>
  </main>
</template>
<script>
import benefitCard from '@/common/components/keyword/BenefitCard.vue';
import {
  mapActions,
  mapGetters,
  mapMutations,
} from '@common/store/modules/keyword';
import * as keywordTypes from '@common/store/modules/keyword/types';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
export default {
  components: {
    benefitCard,
  },
  computed: {
    ...mapGetters({
      sections: keywordTypes.SECTIONS,
    }),
    ...userMapGetters({
      userInfo: userTypes.USER,
    }),
  },
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch();
    });
  },
  methods: {
    ...mapActions([keywordTypes.FETCH_SECTIONS_AREA]),
    ...mapMutations([keywordTypes.SET_SECTION]),
    async fetch() {
      const param = {
        //emdAreaId: this.userInfo.emdAreaId,
        userId: this.userInfo.id,
      };
      await this[keywordTypes.FETCH_SECTIONS_AREA](param);
    },
    goBenefit(section) {
      this[keywordTypes.SET_SECTION](section);
      this.$router.push({
        name: 'keyword.benefit',
      });
    },
  },
};
</script>
